import React, { useState, useEffect } from 'react';
import { useHRMS } from '../context/HRMSContext.jsx';
import api from '../services/api.js';
import Message from '../components/Message.jsx';

function LeaveTypeMaster() {
  const { state, loadLeaveTypes } = useHRMS();
  const [showModal, setShowModal] = useState(false);
  const [editingLeaveType, setEditingLeaveType] = useState(null);
  const [formData, setFormData] = useState({
    leaveName: '',
    paidUnpaid: 'Paid',
    maxPerYear: '',
    byExperience: false,
    experienceRanges: [{
      experienceFrom: '',
      experienceTo: '',
      experienceMaxPerYear: ''
    }]
  });
  const [message, setMessage] = useState({ text: '', type: '' });

  useEffect(() => {
    loadLeaveTypes();
  }, []);

  console.log('LeaveTypes state:', state.leaveTypes);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Check for duplicate leave type name
    const existingLeaveType = (state.leaveTypes || []).find(leaveType => 
      leaveType.leaveName.toLowerCase() === formData.leaveName.toLowerCase() &&
      (!editingLeaveType || leaveType.id !== editingLeaveType.id)
    );
    
    if (existingLeaveType) {
      setMessage({ text: 'Leave type name already exists!', type: 'error' });
      return;
    }
    
    // Validate experience range
    if (formData.byExperience) {
      const firstRange = formData.experienceRanges[0] || {};
      if (parseInt(firstRange.experienceFrom) > parseInt(firstRange.experienceTo)) {
        setMessage({ text: 'From experience must be less than or equal to To experience!', type: 'error' });
        return;
      }
    }
    
    try {
      const firstRange = formData.experienceRanges[0] || {};
      const submitData = {
        leaveName: formData.leaveName,
        paidUnpaid: formData.paidUnpaid,
        maxPerYear: formData.byExperience ? 0 : parseInt(formData.maxPerYear),
        byExperience: formData.byExperience,
        experienceFrom: formData.byExperience ? parseInt(firstRange.experienceFrom) : null,
        experienceTo: formData.byExperience ? parseInt(firstRange.experienceTo) : null,
        experienceMaxPerYear: formData.byExperience ? parseInt(firstRange.experienceMaxPerYear) : null
      };

      if (editingLeaveType) {
        await api.leaveTypes.update(editingLeaveType.id, submitData);
        setMessage({ text: 'Leave type updated successfully!', type: 'success' });
      } else {
        await api.leaveTypes.create(submitData);
        setMessage({ text: 'Leave type created successfully!', type: 'success' });
      }
      loadLeaveTypes();
      resetForm();
    } catch (error) {
      console.error('Error saving leave type:', error);
      setMessage({ text: 'Error saving leave type!', type: 'error' });
    }
  };

  const resetForm = () => {
    setFormData({
      leaveName: '',
      paidUnpaid: 'Paid',
      maxPerYear: '',
      byExperience: false,
      experienceRanges: [{
        experienceFrom: '',
        experienceTo: '',
        experienceMaxPerYear: ''
      }]
    });
    setShowModal(false);
    setEditingLeaveType(null);
  };

  const handleEdit = (leaveType) => {
    setEditingLeaveType(leaveType);
    setFormData({
      leaveName: leaveType.leaveName,
      paidUnpaid: leaveType.paidUnpaid,
      maxPerYear: '', // Always empty in edit mode
      byExperience: leaveType.byExperience || false,
      experienceRanges: [{
        experienceFrom: leaveType.experienceFrom ? leaveType.experienceFrom.toString() : '',
        experienceTo: leaveType.experienceTo ? leaveType.experienceTo.toString() : '',
        experienceMaxPerYear: leaveType.experienceMaxPerYear ? leaveType.experienceMaxPerYear.toString() : ''
      }]
    });
    setShowModal(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure?')) {
      try {
        await api.leaveTypes.delete(id);
        loadLeaveTypes();
        setMessage({ text: 'Leave type deleted successfully!', type: 'success' });
      } catch (error) {
        console.error('Error deleting leave type:', error);
        setMessage({ text: 'Error deleting leave type!', type: 'error' });
      }
    }
  };

  return (
    <div className="leave-type-master">
      {message.text && (
        <Message 
          message={message.text} 
          type={message.type} 
          onClose={() => setMessage({ text: '', type: '' })} 
        />
      )}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h2>Leave Type Master</h2>
        <button className="btn btn-outline-primary" onClick={() => setShowModal(true)}>
          Add Leave Type
        </button>
      </div>

      {showModal && (
        <div className="modal" style={{display: 'block', backgroundColor: 'rgba(0,0,0,0.3)'}}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content shadow-sm border-0">
              <div className="modal-header border-bottom" style={{backgroundColor: 'var(--primary-light)'}}>
                <h6 className="modal-title" style={{color: 'var(--primary-color)'}}>{editingLeaveType ? 'Edit' : 'Add'} Leave Type</h6>
                <button type="button" className="btn-close" onClick={resetForm}></button>
              </div>
              <form onSubmit={handleSubmit}>
                <div className="modal-body p-3">
                  <div className="row g-2">
                    <div className="col-12">
                      <label className="form-label small text-muted">Leave Name *</label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        value={formData.leaveName}
                        onChange={(e) => setFormData({...formData, leaveName: e.target.value})}
                        required
                      />
                    </div>
                    <div className="col-6">
                      <label className="form-label small text-muted">Type *</label>
                      <select
                        className="form-select form-select-sm"
                        value={formData.paidUnpaid}
                        onChange={(e) => setFormData({...formData, paidUnpaid: e.target.value})}
                        required
                      >
                        <option value="Paid">Paid</option>
                        <option value="Unpaid">Unpaid</option>
                      </select>
                    </div>
                    <div className="col-6">
                      <label className="form-label small text-muted">Max Per Year {!formData.byExperience && '*'}</label>
                      <input
                        type="number"
                        className="form-control form-control-sm"
                        value={formData.maxPerYear}
                        onChange={(e) => setFormData({...formData, maxPerYear: e.target.value})}
                        placeholder="Enter number"
                        required={!formData.byExperience}
                        disabled={formData.byExperience}
                      />
                      {!formData.byExperience && (
                        <button 
                          type="button" 
                          className="btn btn-sm btn-outline-success mt-1 w-100"
                          onClick={() => {
                            // Copy current form data and reset for new entry
                            const currentData = {
                              leaveName: formData.leaveName,
                              paidUnpaid: formData.paidUnpaid,
                              maxPerYear: formData.maxPerYear
                            };
                            // Reset form but keep copied values as reference
                            setFormData({
                              ...formData,
                              leaveName: formData.leaveName + ' (Copy)',
                              maxPerYear: formData.maxPerYear
                            });
                          }}
                          title="Copy current values to create similar leave type"
                        >
                          + Copy & Add New
                        </button>
                      )}
                    </div>
                    <div className="col-12">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="byExperience"
                          checked={formData.byExperience}
                          onChange={(e) => setFormData({...formData, byExperience: e.target.checked})}
                        />
                        <label className="form-check-label small text-muted" htmlFor="byExperience">
                          Experience-based Leave (Check worker's joining date)
                        </label>
                      </div>
                    </div>
                    {formData.byExperience && (
                      <>
                        <div className="col-12">
                          <div className="alert alert-info py-2 mb-2">
                            <small><strong>Experience-based Leave:</strong> Workers can only apply if their experience (from joining date) falls within the specified range.</small>
                          </div>
                        </div>
                        {formData.experienceRanges.map((range, index) => (
                          <React.Fragment key={index}>
                            <div className="col-4">
                              <label className="form-label small text-muted">Max Per Year *</label>
                              <input
                                type="number"
                                className="form-control form-control-sm"
                                value={range.experienceMaxPerYear}
                                onChange={(e) => {
                                  const newRanges = [...formData.experienceRanges];
                                  newRanges[index].experienceMaxPerYear = e.target.value;
                                  setFormData({...formData, experienceRanges: newRanges});
                                }}
                                placeholder="Enter number"
                                required
                              />
                            </div>
                            <div className="col-4">
                              <label className="form-label small text-muted">From (Years) *</label>
                              <input
                                type="number"
                                className="form-control form-control-sm"
                                value={range.experienceFrom}
                                onChange={(e) => {
                                  const newRanges = [...formData.experienceRanges];
                                  newRanges[index].experienceFrom = e.target.value;
                                  setFormData({...formData, experienceRanges: newRanges});
                                }}
                                min="0"
                                placeholder="e.g. 1"
                                required
                              />
                            </div>
                            <div className="col-4">
                              <label className="form-label small text-muted">To (Years) *</label>
                              <input
                                type="number"
                                className="form-control form-control-sm"
                                value={range.experienceTo}
                                onChange={(e) => {
                                  const newRanges = [...formData.experienceRanges];
                                  newRanges[index].experienceTo = e.target.value;
                                  setFormData({...formData, experienceRanges: newRanges});
                                }}
                                min={range.experienceFrom || "0"}
                                placeholder="e.g. 3"
                                required
                              />
                              {index === formData.experienceRanges.length - 1 && (
                                <button 
                                  type="button" 
                                  className="btn btn-sm btn-outline-primary mt-1 w-100"
                                  onClick={() => {
                                    const newRange = {
                                      experienceMaxPerYear: range.experienceMaxPerYear,
                                      experienceFrom: range.experienceTo ? (parseInt(range.experienceTo) + 1).toString() : '',
                                      experienceTo: ''
                                    };
                                    setFormData({
                                      ...formData, 
                                      experienceRanges: [...formData.experienceRanges, newRange]
                                    });
                                  }}
                                  title="Add new experience range"
                                >
                                  + Add Range
                                </button>
                              )}
                            </div>
                          </React.Fragment>
                        ))}
                      </>
                    )}
                  </div>
                </div>
                <div className="modal-footer bg-light py-2">
                  <button type="submit" className="btn btn-sm btn-primary">
                    Save
                  </button>
                  <button type="button" className="btn btn-sm btn-outline-secondary" onClick={resetForm}>
                    Close
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      <div className="card">
        <div className="card-body">
          <div className="table-responsive">
            <table className="table table-striped">
              <thead>
                <tr>
                  <th>Leave Name</th>
                  <th>Type</th>
                  <th>Max/Year</th>
                  <th>Experience</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {(state.leaveTypes || []).map(leaveType => (
                  <tr key={leaveType.id}>
                    <td>{leaveType.leaveName}</td>
                    <td>
                      <span className={`badge ${leaveType.paidUnpaid === 'Paid' ? 'bg-success' : 'bg-warning'}`}>
                        {leaveType.paidUnpaid}
                      </span>
                    </td>
                    <td>{leaveType.byExperience ? leaveType.experienceMaxPerYear : leaveType.maxPerYear}</td>
                    <td>
                      {leaveType.byExperience ? (
                        <span className="badge bg-info">
                          {leaveType.experienceFrom}-{leaveType.experienceTo} years
                        </span>
                      ) : (
                        <span className="text-muted">-</span>
                      )}
                    </td>
                    <td>
                      <button className="btn btn-sm btn-outline-info me-1" onClick={() => handleEdit(leaveType)}>
                        Edit
                      </button>
                      <button className="btn btn-sm btn-outline-warning" onClick={() => handleDelete(leaveType.id)}>
                        Delete
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LeaveTypeMaster;